// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import i18n from '@/language'

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
// 第三方
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})

Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js